export const SOCIAL_PUBLISHER_CREDITS_PER_VIDEO = 10;
export const SOCIAL_PUBLISHER_CREDITS_DAILY_CAP = 200;
